document.addEventListener('DOMContentLoaded', function() {
  const videoItems = document.querySelectorAll('.custom-video-item');

  videoItems.forEach(function(item) {
    const videoEl = item.querySelector('video');
    const playButton = item.querySelector('.play-button');
    const videoWrapper = item.querySelector('.custom-video-wrapper');

    playButton.addEventListener('click', function(e) {
      e.stopPropagation();
      videoEl.play();
    });

    videoWrapper.addEventListener('click', e => {
      if (videoEl.controls) return;

      videoEl.paused ? videoEl.play() : videoEl.pause();
    });

    videoEl.addEventListener('play', function() {
      const allVideos = document.querySelectorAll('.custom-video-block video');
      
      allVideos.forEach(function(otherVideo) {
        if (otherVideo !== videoEl) {
          otherVideo.pause();
        }
      });

      videoEl.controls = true;
      playButton.style.display = 'none';
    });

    videoEl.addEventListener('pause', function() {
      videoEl.controls = false;
      playButton.style.display = 'block';
    });

    videoEl.addEventListener('ended', function() {
      videoEl.controls = false;
      playButton.style.display = 'block';
    });
  });
});